import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class MicrosoftAdapterHelper  {
    _originalTypeClassName = "ekylikeio.BO.MicrosoftAdapterHelper";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
MicrosoftAdapterHelper.translate = translateService;
}
this.MicrosoftAdapterHelperKey = null;
this._key = this.MicrosoftAdapterHelperKey = 0; 
}

static translate: TranslateService;
_key: any;
private _MicrosoftAdapterHelperKey:any;
get MicrosoftAdapterHelperKey(): any {
    return this._MicrosoftAdapterHelperKey;
  }
set MicrosoftAdapterHelperKey(value: any) {
    this._MicrosoftAdapterHelperKey = value;
    this._key = value;
  }

static GetAuthorizationHeaderForCurrentUser(): any{let user = Domain.UserAcount.GetActive();
return Domain.MicrosoftAdapterHelper.GetAuthorizationHeaderForUser(user);
}
static GetAuthorizationHeaderForUser(user: any): any{if (user == null) {return null;}
if (user?.UserAccountOAuthInfo == null) {return null;}
let header = CLMS.Framework.String.Format("Bearer {0}", user?.UserAccountOAuthInfo?.AccessToken);
return header;
}
static Scopes(): any{return "openid profile";
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.MicrosoftAdapterHelperKey == null || $this.MicrosoftAdapterHelperKey == 0;
            }


}